import HomeService from '@baserow/modules/core/services/home'

/**
 * Origem Flow: contadores de linhas por tabela para os badges da sidebar
 * (estilo ClickUp). "open" = linhas cujo status não é Concluído/Cancelado;
 * tabelas sem campo de status contam todas as linhas.
 */

// Idade máxima (ms) do cache antes de uma nova busca para o mesmo workspace.
const TTL_MS = 30 * 1000

export const state = () => ({
  workspaceId: null,
  counts: {},
  fetchedAt: 0,
  loading: false,
})

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_COUNTS(state, { workspaceId, counts }) {
    state.workspaceId = workspaceId
    state.counts = counts
    state.fetchedAt = Date.now()
  },
}

export const actions = {
  /**
   * Busca os contadores do workspace. Com `force: false` a chamada é
   * ignorada se já existir um cache recente do mesmo workspace — vários
   * componentes podem despachar sem gerar tempestade de requests.
   */
  async fetch({ state, commit }, { workspaceId, force = false }) {
    const fresh =
      state.workspaceId === workspaceId && Date.now() - state.fetchedAt < TTL_MS
    if (state.loading || (fresh && !force)) {
      return
    }
    commit('SET_LOADING', true)
    try {
      const { data } = await HomeService(this.$client).fetchTableCounts(
        workspaceId
      )
      commit('SET_COUNTS', { workspaceId, counts: data.counts || {} })
    } finally {
      commit('SET_LOADING', false)
    }
  },
}

export const getters = {
  getOpenCount: (state) => (tableId) => {
    const entry = state.counts[String(tableId)]
    return entry ? entry.open : null
  },
  getTotalCount: (state) => (tableId) => {
    const entry = state.counts[String(tableId)]
    return entry ? entry.total : null
  },
  getWorkspaceId(state) {
    return state.workspaceId
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
